import { WelcomeComponent } from './../modulos/principal/ui/welcome/welcome.component';
import { Utils } from './utils';
import { LogService } from './../commons/servicos/log.service';
import { UserUtil } from './user-util';
import { LoginService } from './../commons/servicos/login.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
 }

@Injectable()
export class CanDeactivateGuardService implements CanDeactivate<CanComponentDeactivate> {

  constructor(private loginService: LoginService,  private logService: LogService) { }

  canDeactivate(component: CanComponentDeactivate) {
    this.loginService.setAction(5, UserUtil.usuarioLogado.unidPolicial.unidadePolicialPK.cdAgencia,
      UserUtil.usuarioLogado.unidPolicial.unidadePolicialPK.cdUnidPolicial).subscribe(respota => { });
      this.logSaidaTela(WelcomeComponent.path[0]);
    const existeFuncao = component.canDeactivate;
    if(existeFuncao) {
      return component.canDeactivate();
    }
    return true;

  }

  logSaidaTela(tela: any): void {
    this.logService.criaRegistroLog(UserUtil.usuarioLogado.login,  tela, '9', 2,
    'O usuario: ' + UserUtil.usuarioLogado.nome + ' saiu da tela: ' + tela + ' as: ' + Utils.formataData(UserUtil.sysdate)).subscribe(respota => { });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/can-deactivate-guard.service.ts